'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createStore;

var _redux = require('redux');

var _reactIntl = require('react-intl');

var _analyticsActionMapper = require('./middleware/analyticsActionMapper');

var _analyticsActionMapper2 = _interopRequireDefault(_analyticsActionMapper);

var _reduxDevtoolsExtension = require('redux-devtools-extension');

var _logger = require('./middleware/logger');

var _logger2 = _interopRequireDefault(_logger);

var _reduxSegment = require('redux-segment');

var _en = require('react-intl/locale-data/en');

var _en2 = _interopRequireDefault(_en);

var _riskified = require('./middleware/riskified');

var _riskified2 = _interopRequireDefault(_riskified);

var _reactRouterRedux = require('react-router-redux');

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _reactIntl.addLocaleData)(_en2.default);

function createStore(history, data) {
    // middlewares
    var middleware = [(0, _reactRouterRedux.routerMiddleware)(history), _reduxThunk2.default, _riskified2.default];

    if (__DEVELOPMENT__) {
        middleware.push((0, _logger2.default)({ client: true, server: true }));
        middleware.push(require('redux-immutable-state-invariant').default());
    } else {
        middleware.push((0, _reduxSegment.createTracker)(_analyticsActionMapper2.default));
    }

    // enhancers
    var enhancers = [_redux.applyMiddleware.apply(undefined, middleware)];

    var compose = (0, _reduxDevtoolsExtension.composeWithDevTools)({});
    var finalCreateStore = compose.apply(undefined, enhancers)(_redux.createStore);

    var reducer = require('./rootReducer');
    var store = finalCreateStore(reducer, data);
    return store;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/create.js
// module id = 0lB/
// module chunks = 57